import GoogleAdSmall1 from "@/components/Ads/GoogleAdSmall1";
import GoogleAdSmall2 from "@/components/Ads/GoogleAdSmall2";
import GoogleAdSmall3 from "@/components/Ads/GoogleAdSmall3";
import GoogleAdSquare from "@/components/Ads/GoogleAdSquare";
import React, { useState } from "react";
import CPAggregator from "@/models/CPAggregator";
import CPTagsAggregator from "@/models/CPTagsAggregator";
import Link from "next/link";

const CourseSidebar = ({ courses }) => {
  const [showMoreCategory, setShowMoreCategory] = useState(false);
  const [showMoreProvider, setShowMoreProvider] = useState(false);

  // console.log(courses)

  // extract list of Providers from the Event list (including count) then sort based on count-desc
  const providerAggregator = new CPAggregator(courses, "provider")
  const providers = providerAggregator.list
  // console.log(providers)

  // extract list of Categories from the Event list (including count) then sort based on count-desc
  const categoryAggregator = new CPAggregator(courses, "category")
  const categories = categoryAggregator.list

  // extract list of Tags from the Event list (including count) then sort based on count-desc
  const tagsAggregator = new CPTagsAggregator(courses)
  const tags = tagsAggregator.list
  // console.log(tags)


  return (
    <>
      <aside className="rbt-sidebar-widget-wrapper rbt-gradient-border">
        {/* <div className="rbt-single-widget rbt-widget-search">
          <div className="inner">
            <form action="#" className="rbt-search-style-1">
              <input type="text" placeholder="Search Courses" />
              <button className="search-btn">
                <i className="feather-search"></i>
              </button>
            </form>
          </div>
        </div> */}

        <div
          className={`rbt-single-widget rbt-widget-categories ${showMoreCategory ? "has-show-more" : ""}`}
        >
          <div className="inner">
            <h4 className="rbt-widget-title">Categories</h4>
            <ul className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content">
              {categories &&
                categories.map((data, index) => (
                  <li className="rbt-check-group" key={index}>
                    <input id={`category-${data.id}`} type="checkbox" name={`category-${data.id}`} />
                    <label htmlFor={`category-${data.id}`}>
                      {data.name}
                      <span className="rbt-lable count">{data.count}</span>
                    </label>
                  </li>
                ))}
            </ul>
          </div>
          <div
            className={`rbt-show-more-btn ${showMoreCategory ? "active" : ""}`}
            onClick={() => setShowMoreCategory(!showMoreCategory)}
          >
            {showMoreCategory ? "Show Less" : "Show More"}
          </div>
        </div>

        <GoogleAdSmall1 />

        {/* <div className="rbt-single-widget rbt-widget-rating">
          <div className="inner">
            <h4 className="rbt-widget-title">Ratings</h4>
            <ul className="rbt-sidebar-list-wrapper rating-list-check">
              <li className="rbt-check-group">
                <input id="cat-radio-1" type="radio" name="rbt-radio" />
                <label htmlFor="cat-radio-1">
                  <span className="rating">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </span>
                  <span className="rbt-lable count">5</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input id="cat-radio-2" type="radio" name="rbt-radio" />
                <label htmlFor="cat-radio-2">
                  <span className="rating">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                  </span>
                  <span className="rbt-lable count">4</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input id="cat-radio-3" type="radio" name="rbt-radio" />
                <label htmlFor="cat-radio-3">
                  <span className="rating">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                  </span>
                  <span className="rbt-lable count">3</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input id="cat-radio-4" type="radio" name="rbt-radio" />
                <label htmlFor="cat-radio-4">
                  <span className="rating">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                  </span>
                  <span className="rbt-lable count">2</span>
                </label>
              </li>

              <li className="rbt-check-group">
                <input id="cat-radio-5" type="radio" name="rbt-radio" />
                <label htmlFor="cat-radio-5">
                  <span className="rating">
                    <i className="fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                    <i className="off fas fa-star"></i>
                  </span>
                  <span className="rbt-lable count">1</span>
                </label>
              </li>
            </ul>
          </div>
        </div> */}


        <div
          className={`rbt-single-widget rbt-widget-categories has-show-more ${showMoreProvider ? "active" : ""
            }`}
        >
          <div className="inner">
            <h4 className="rbt-widget-title">Providers</h4>
            <ul className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content">
              {providers &&
                providers.map((data, index) => (
                  <li className="rbt-check-group" key={index}>
                    <input id={`provider-${data.id}`} type="checkbox" name={`provider-${data.id}`} />
                    <label htmlFor={`provider-${data.id}`}>
                      {data.name}
                      <span className="rbt-lable count">{data.count}</span>
                    </label>
                  </li>
                ))}
            </ul>
          </div>
          <div
            className={`rbt-show-more-btn ${showMoreProvider ? "active" : ""}`}
            onClick={() => setShowMoreProvider(!showMoreProvider)}
          >
            {showMoreProvider ? "Show Less" : "Show More"}
          </div>
        </div>


        <GoogleAdSmall2 />

        <div className="rbt-single-widget rbt-widget-prices">
          <div className="inner">
            <h4 className="rbt-widget-title">Prices</h4>
            <ul className="rbt-sidebar-list-wrapper prices-list-check">
              <li className="rbt-check-group">
                <input
                  id="prices-list-1"
                  type="checkbox"
                  name="prices-list-1"
                />
                <label htmlFor="prices-list-1">
                  All <span className="rbt-lable count">15</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input
                  id="prices-list-2"
                  type="checkbox"
                  name="prices-list-2"
                />
                <label htmlFor="prices-list-2">
                  Free <span className="rbt-lable count">0</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input
                  id="prices-list-3"
                  type="checkbox"
                  name="prices-list-3"
                />
                <label htmlFor="prices-list-3">
                  Paid <span className="rbt-lable count">10</span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <GoogleAdSmall3 />

        <div className="rbt-single-widget rbt-widget-lavels">
          <div className="inner">
            <h4 className="rbt-widget-title">Levels</h4>
            <ul className="rbt-sidebar-list-wrapper lavels-list-check">
              <li className="rbt-check-group">
                <input
                  id="lavels-list-1"
                  type="checkbox"
                  name="lavels-list-1"
                />
                <label htmlFor="lavels-list-1">
                  All Levels<span className="rbt-lable count">15</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input
                  id="lavels-list-2"
                  type="checkbox"
                  name="lavels-list-2"
                />
                <label htmlFor="lavels-list-2">
                  Beginner <span className="rbt-lable count">0</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input
                  id="lavels-list-3"
                  type="checkbox"
                  name="lavels-list-3"
                />
                <label htmlFor="lavels-list-3">
                  Intermediate <span className="rbt-lable count">10</span>
                </label>
              </li>
              <li className="rbt-check-group">
                <input
                  id="lavels-list-4"
                  type="checkbox"
                  name="lavels-list-4"
                />
                <label htmlFor="lavels-list-4">
                  Expert <span className="rbt-lable count">10</span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div className="rbt-single-widget rbt-widget-tag">
          <div className="inner">
            <h4 className="rbt-widget-title">Tags</h4>
            <div className="rbt-sidebar-list-wrapper rbt-tag-list">
              {tags &&
                tags.map((tag) => (
                  <Link key={tag.id} href="#">
                    {tag.name}
                  </Link>
                ))}
            </div>
          </div>
        </div>

        <GoogleAdSquare />
      </aside>
    </>
  );
};

export default CourseSidebar;
